"use client"

import type React from "react"
import { useState } from "react"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { ConfigProvider } from "@packages/web/components/ConfigProvider"
import { ThemeProvider } from "@packages/web/components/ThemeProvider"
import { Toaster } from "@packages/web/components/ui/toaster"

import { buildBackapiUrl, initBackapiUrl } from "@packages/base/utils/fastapi"
import { initSupabaseClient } from "@packages/base/utils/supabase"

import * as config from "@/app/config"
import AuthErrorCatcher from "@/components/AuthErrorCatcher"
import { SUPABASE_ANON_KEY, SUPABASE_URL } from "@/utils/supabase"

if (SUPABASE_URL && SUPABASE_ANON_KEY) {
  initSupabaseClient(SUPABASE_URL, SUPABASE_ANON_KEY)
}

initBackapiUrl(
  buildBackapiUrl({
    backapiUrl: process.env.NEXT_PUBLIC_BACKAPI_URL,
    domain: config.DOMAIN,
    environment: config.ENVIRONMENT,
    platform: config.PLATFORM,
  }),
)

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient())
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider value={{...config}}>
        <ThemeProvider
          attribute="class"
          defaultTheme="light"
          enableSystem
          disableTransitionOnChange
        >
          <AuthErrorCatcher />
          {children}
          <Toaster />
        </ThemeProvider>
      </ConfigProvider>
    </QueryClientProvider>
  )
}
